// <pos-auth-gate/> — 路由守衛
// - 公開路由（routes.js guard:'public'，如 #/order/... #/reserve/...）→ 直接 slot（無需 auth）
// - 無 session → <pos-login/>
// - 有 session 但無 tenant_id → <pos-tenant-setup/>
// - 有 session + tenant_id → slot (主應用)
// see architecture.md#L280, L580

import { getSupabase } from '../lib/supabase-client.js';
import { matchRoute } from '../pos/routes.js';

function decodeJwtPayload(token) {
  try {
    const base64 = token.split('.')[1];
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = atob(padded.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

// 以 routes.js 的 guard:'public' 為單一事實來源（先前用 hardcode regex
// 只放行 #/order/，漏掉 #/reserve/ 導致未登入顧客的訂位連結被擋成登入頁）
function isPublicHash(hash) {
  return matchRoute(hash || '')?.guard === 'public';
}

class PosAuthGate extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  async connectedCallback() {
    const supabase = getSupabase();
    const { data } = await supabase.auth.getSession();
    this.renderForSession(data?.session);

    supabase.auth.onAuthStateChange((_event, session) => {
      document.body.dataset.authed = session ? 'true' : 'false';
      this.renderForSession(session);
    });

    // 路由變更時也要重判（公開路由與否可能切換）
    window.addEventListener('hashchange', async () => {
      const { data: s } = await supabase.auth.getSession();
      this.renderForSession(s?.session);
    });
  }

  renderForSession(session) {
    // 公開路由（QR 顧客頁）無條件通過 auth-gate
    if (isPublicHash(location.hash)) {
      this.shadowRoot.innerHTML = `<slot></slot>`;
      return;
    }
    if (!session) {
      this.shadowRoot.innerHTML = `<pos-login></pos-login>`;
      return;
    }
    const claims = decodeJwtPayload(session.access_token);
    const tenantId = claims?.tenant_id;
    if (!tenantId) {
      this.shadowRoot.innerHTML = `<pos-tenant-setup></pos-tenant-setup>`;
      return;
    }
    this.shadowRoot.innerHTML = `<slot></slot>`;
  }
}

customElements.define('pos-auth-gate', PosAuthGate);
